
export const PUSH_STATE_EVENT = 'pv-spa-pushreactrouter'
export const REPLACE_STATE_EVENT = 'pv-spa-replacereactrouter'

export const pushState = (state: object|null, title: string, url?: string) => {
  if(global.__NATIVEAPP__ && typeof window !== 'undefined' && window.history)  {
    /*
    * Calling window.history.pushState() or window.history.replaceState() won't trigger a popstate event and without this event the history changes will not be caught by React-Router and we will end up with window.history and React-Router history being out of sync.
    * So we have to manually trigger a CustomEvent for the Windows Client SPA to catch the fact we are "changing" page (either pushing or replacing in the history) and then use react router own history instance to push/replace.
    * React-Router: https://github.com/ReactTraining/react-router/issues/6304 MDN: https://developer.mozilla.org/en-US/docs/Web/API/PopStateEvent
    */

    const event = new CustomEvent(PUSH_STATE_EVENT, { detail: { state, url } });
    window.dispatchEvent(event)
  } else if(typeof window !== 'undefined' && window.history) {
    window.history.pushState(state, title, url)
  }
}

export const replaceState = (state: object|null, title: string, url?: string) => {
  if(global.__NATIVEAPP__ && typeof window !== 'undefined' && window.history)  {
    /*
    * Calling window.history.pushState() or window.history.replaceState() won't trigger a popstate event and without this event the history changes will not be caught by React-Router and we will end up with window.history and React-Router history being out of sync.
    * So we have to manually trigger a CustomEvent for the Windows Client SPA to catch the fact we are "changing" page (either pushing or replacing in the history) and then use react router own history instance to push/replace.
    * React-Router: https://github.com/ReactTraining/react-router/issues/6304 MDN: https://developer.mozilla.org/en-US/docs/Web/API/PopStateEvent
    */
    
    const event = new CustomEvent(REPLACE_STATE_EVENT, { detail: { state, url } })
    window.dispatchEvent(event)
  } else if(typeof window !== 'undefined' && window.history) {
    window.history.replaceState(state, title, url)
  }
}